import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { router } from './app/router';
import './index.css';

/*
 * There is no theme to set before the first paint.
 *
 * The product ships one theme. Nothing here reads `prefers-color-scheme`,
 * nothing reads or writes a stored preference, and nothing sets `data-theme` —
 * which is why this file no longer runs anything before mounting.
 * `lib/single-theme.spec.ts` holds that as an assertion over the source rather
 * than as a comment.
 */

const container = document.getElementById('root');
if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Operational data goes stale fast — a schedule from thirty seconds ago
      // is a schedule someone has already changed.
      staleTime: 30_000,
      retry: 1,
    },
  },
});

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
